// Ikony cz. 2 - sprzęt, pomiary, media i pozostałe (importuj przez ./ikony - jeden adres dla całej APP).
import { Svg, type IkonaProps } from "./ikony-svg";

export function IkonaBluetooth(props: IkonaProps) {
  return <Svg {...props}><path d="m7 7 10 10-5 5V2l5 5L7 17" /></Svg>;
}

export function IkonaPlomien(props: IkonaProps) {
  return <Svg {...props}><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.07-2.14-.22-4.05 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.15.43-2.29 1-3a2.5 2.5 0 0 0 2.5 2.5z" /></Svg>;
}

export function IkonaKropla(props: IkonaProps) {
  return <Svg {...props}><path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z" /></Svg>;
}

export function IkonaTermometr(props: IkonaProps) {
  return <Svg {...props}><path d="M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z" /></Svg>;
}

export function IkonaZegar(props: IkonaProps) {
  return <Svg {...props}><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></Svg>;
}

export function IkonaPogoda(props: IkonaProps) {
  return <Svg {...props}><path d="M12 2v2M4.93 4.93l1.41 1.41M20 12h2M19.07 4.93l-1.41 1.41M15.95 12.65A4 4 0 0 0 8.1 11" /><path d="M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6z" /></Svg>;
}

export function IkonaWiatr(props: IkonaProps) {
  return <Svg {...props}><path d="M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2M9.6 4.6A2 2 0 1 1 11 8H2M12.6 19.4A2 2 0 1 0 14 16H2" /></Svg>;
}

export function IkonaAparat(props: IkonaProps) {
  return <Svg {...props}><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z" /><circle cx="12" cy="13" r="3" /></Svg>;
}

export function IkonaObraz(props: IkonaProps) {
  return <Svg {...props}><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="9" cy="9" r="2" /><path d="m21 15-3.1-3.1a2 2 0 0 0-2.8 0L6 21" /></Svg>;
}

export function IkonaPobierz(props: IkonaProps) {
  return <Svg {...props}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" /></Svg>;
}

export function IkonaWyslij(props: IkonaProps) {
  return <Svg {...props}><path d="m22 2-7 20-4-9-9-4z" /><path d="M22 2 11 13" /></Svg>;
}

export function IkonaGwiazda(props: IkonaProps) {
  return <Svg {...props}><path d="m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z" /></Svg>;
}

export function IkonaSerce(props: IkonaProps) {
  return <Svg {...props}><path d="M19 14c1.5-1.5 3-3.2 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.8 0-3 .5-4.5 2-1.5-1.5-2.7-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4 3 5.5l7 7z" /></Svg>;
}

export function IkonaFiltr(props: IkonaProps) {
  return <Svg {...props}><path d="M22 3H2l8 9.5V19l4 2v-8.5z" /></Svg>;
}

export function IkonaSortuj(props: IkonaProps) {
  return <Svg {...props}><path d="m3 16 4 4 4-4M7 20V4M21 8l-4-4-4 4M17 4v16" /></Svg>;
}

export function IkonaOko(props: IkonaProps) {
  return <Svg {...props}><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" /></Svg>;
}

export function IkonaOkoOff(props: IkonaProps) {
  return <Svg {...props}><path d="M9.9 4.24A9 9 0 0 1 12 4c7 0 10 8 10 8a13 13 0 0 1-1.67 2.68M6.61 6.61A13.5 13.5 0 0 0 2 12s3 8 10 8a9.7 9.7 0 0 0 5.39-1.61M2 2l20 20M14.12 14.12a3 3 0 1 1-4.24-4.24" /></Svg>;
}

export function IkonaKlodka(props: IkonaProps) {
  return <Svg {...props}><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></Svg>;
}

export function IkonaMail(props: IkonaProps) {
  return <Svg {...props}><rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 6L2 7" /></Svg>;
}

export function IkonaQr(props: IkonaProps) {
  return <Svg {...props}><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><path d="M14 14h3v3h-3zM20 14v.01M14 20h.01M17 17h4v4h-4" /></Svg>;
}

export function IkonaZasilanie(props: IkonaProps) {
  return <Svg {...props}><path d="M12 2v10" /><path d="M18.4 6.6a9 9 0 1 1-12.77.04" /></Svg>;
}

export function IkonaStart(props: IkonaProps) {
  return <Svg {...props}><path d="m6 3 14 9-14 9z" /></Svg>;
}

export function IkonaStop(props: IkonaProps) {
  return <Svg {...props}><rect x="5" y="5" width="14" height="14" rx="2" /></Svg>;
}

export function IkonaOdswiez(props: IkonaProps) {
  return <Svg {...props}><path d="M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5M21 12a9 9 0 0 1-15 6.7L3 16M3 21v-5h5" /></Svg>;
}

export function IkonaLink(props: IkonaProps) {
  return <Svg {...props}><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" /><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" /></Svg>;
}

export function IkonaInfo(props: IkonaProps) {
  return <Svg {...props}><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" /></Svg>;
}

export function IkonaTelefon(props: IkonaProps) {
  return <Svg {...props}><rect x="5" y="2" width="14" height="20" rx="2" /><path d="M12 18h.01" /></Svg>;
}

export function IkonaTablet(props: IkonaProps) {
  return <Svg {...props}><rect x="3" y="2" width="18" height="20" rx="2" /><path d="M12 18h.01" /></Svg>;
}

export function IkonaMonitor(props: IkonaProps) {
  return <Svg {...props}><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" /></Svg>;
}

export function IkonaZarowka(props: IkonaProps) {
  return <Svg {...props}><path d="M9 18h6M10 22h4M15.1 14c.2-1 .7-1.7 1.4-2.5A6 6 0 1 0 6 8c0 1.4.4 2.6 1.5 3.5.7.7 1.2 1.5 1.4 2.5" /></Svg>;
}

export function IkonaZawor(props: IkonaProps) {
  return <Svg {...props}><path d="M2 12h4M18 12h4M6 7v10l12-10v10z" /></Svg>;
}

export function IkonaPompa(props: IkonaProps) {
  return <Svg {...props}><circle cx="12" cy="12" r="7" /><path d="M12 5v7l5 4M2 12h3M19 12h3" /></Svg>;
}

export function IkonaUloz(props: IkonaProps) {
  return <Svg {...props}><path d="m5 9-3 3 3 3M9 5l3-3 3 3M15 19l-3 3-3-3M19 9l3 3-3 3M2 12h20M12 2v20" /></Svg>;
}

export function IkonaKopiuj(props: IkonaProps) {
  return <Svg {...props}><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></Svg>;
}

export function IkonaKoszyk(props: IkonaProps) {
  return <Svg {...props}><circle cx="8" cy="21" r="1" /><circle cx="19" cy="21" r="1" /><path d="M2 2h3l2.7 12.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6" /></Svg>;
}

export function IkonaWaga(props: IkonaProps) {
  return <Svg {...props}><path d="M12 3v18M6 21h12M3 7h18M6 7l-3 7a3 3 0 0 0 6 0zM18 7l-3 7a3 3 0 0 0 6 0z" /></Svg>;
}

export function IkonaSpinacz(props: IkonaProps) {
  return <Svg {...props}><path d="m21.4 11-9.2 9.2a6 6 0 0 1-8.5-8.5l9.2-9.2a4 4 0 0 1 5.7 5.7l-9.2 9.2a2 2 0 0 1-2.8-2.8l8.5-8.5" /></Svg>;
}

export function IkonaFilm(props: IkonaProps) {
  return <Svg {...props}><rect x="2" y="5" width="15" height="14" rx="2" /><path d="m22 8-5 4 5 4z" /></Svg>;
}

export function IkonaIskry(props: IkonaProps) {
  return <Svg {...props}><path d="m12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" /><path d="m19 15 .8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z" /></Svg>;
}

export function IkonaKciuk(props: IkonaProps) {
  return <Svg {...props}><path d="M7 10v12M15 5.9 14 10h5.8a2 2 0 0 1 2 2.3l-1.4 8A2 2 0 0 1 18.4 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.8a2 2 0 0 0 1.8-1.1L12 2a3.1 3.1 0 0 1 3 3.9z" /></Svg>;
}

export function IkonaPlik(props: IkonaProps) {
  return <Svg {...props}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M8 13h8M8 17h5" /></Svg>;
}

export function IkonaPinezka(props: IkonaProps) {
  return <Svg {...props}><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" /><circle cx="12" cy="10" r="3" /></Svg>;
}

export function IkonaJezyk(props: IkonaProps) {
  return <Svg {...props}><circle cx="12" cy="12" r="10" /><path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20" /></Svg>;
}

export function IkonaTarcza(props: IkonaProps) {
  return <Svg {...props}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></Svg>;
}

export function IkonaKlucz(props: IkonaProps) {
  return <Svg {...props}><circle cx="7.5" cy="15.5" r="5.5" /><path d="m21 2-9.6 9.6M15.5 7.5l3 3L22 7l-3-3" /></Svg>;
}

export function IkonaEtykieta(props: IkonaProps) {
  return <Svg {...props}><path d="M12.6 2.6A2 2 0 0 0 11.2 2H4a2 2 0 0 0-2 2v7.2a2 2 0 0 0 .6 1.4l8.7 8.7a2.4 2.4 0 0 0 3.4 0l6.6-6.6a2.4 2.4 0 0 0 0-3.4z" /><circle cx="7.5" cy="7.5" r="1.5" /></Svg>;
}

export function IkonaPuchar(props: IkonaProps) {
  return <Svg {...props}><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6M18 9h1.5a2.5 2.5 0 0 0 0-5H18M4 22h16M10 14.7V17c0 .6-.5 1-1 1.2C7.8 18.8 7 20.2 7 22M14 14.7V17c0 .6.5 1 1 1.2 1.2.6 2 2 2 3.8M18 2H6v7a6 6 0 0 0 12 0z" /></Svg>;
}

export function IkonaWtyczka(props: IkonaProps) {
  return <Svg {...props}><path d="M12 22v-5M9 8V2M15 8V2M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8z" /></Svg>;
}

export function IkonaCisnienie(props: IkonaProps) {
  return <Svg {...props}><path d="m12 14 4-4" /><path d="M3.34 19a10 10 0 1 1 17.32 0" /></Svg>;
}

export function IkonaDom(props: IkonaProps) {
  return <Svg {...props}><path d="m3 10 9-7 9 7v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><path d="M9 22V12h6v10" /></Svg>;
}

export function IkonaWedzarnia(props: IkonaProps) {
  return <Svg {...props}><path d="M4 21V10l8-6 8 6v11z" /><path d="M9 21v-5h6v5M16 2c-1 1 1 2 0 3" /></Svg>;
}

export function IkonaKolumna(props: IkonaProps) {
  return <Svg {...props}><path d="M9 2h4v11H9zM7 13h8v5a4 4 0 0 1-8 0zM13 5h5l2 4v7" /></Svg>;
}

export function IkonaHistoria(props: IkonaProps) {
  return <Svg {...props}><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5M12 7v5l4 2" /></Svg>;
}

export function IkonaKalendarz(props: IkonaProps) {
  return <Svg {...props}><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></Svg>;
}

export function IkonaLista(props: IkonaProps) {
  return <Svg {...props}><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" /></Svg>;
}

export function IkonaPaczka(props: IkonaProps) {
  return <Svg {...props}><path d="M21 8 12 3 3 8v8l9 5 9-5z" /><path d="m3 8 9 5 9-5M12 13v8" /></Svg>;
}

export function IkonaKlepsydra(props: IkonaProps) {
  return <Svg {...props}><path d="M5 22h14M5 2h14M17 22v-4.2a2 2 0 0 0-.6-1.4L12 12l-4.4 4.4a2 2 0 0 0-.6 1.4V22M7 2v4.2a2 2 0 0 0 .6 1.4L12 12l4.4-4.4a2 2 0 0 0 .6-1.4V2" /></Svg>;
}

export function IkonaCel(props: IkonaProps) {
  return <Svg {...props}><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" /></Svg>;
}

export function IkonaWykrzyknik(props: IkonaProps) {
  return <Svg {...props}><circle cx="12" cy="12" r="10" /><path d="M12 8v4M12 16h.01" /></Svg>;
}

export function IkonaOkKolo(props: IkonaProps) {
  return <Svg {...props}><circle cx="12" cy="12" r="10" /><path d="m8 12 3 3 5-6" /></Svg>;
}

export function IkonaDrukuj(props: IkonaProps) {
  return <Svg {...props}><path d="M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" /><rect x="6" y="14" width="12" height="8" /></Svg>;
}

export function IkonaLodowka(props: IkonaProps) {
  return <Svg {...props}><rect x="5" y="2" width="14" height="20" rx="2" /><path d="M5 10h14M15 5v2M15 13v3" /></Svg>;
}

export function IkonaRozmiar(props: IkonaProps) {
  return <Svg {...props}><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" /></Svg>;
}

export function IkonaSrodek(props: IkonaProps) {
  return <Svg {...props}><circle cx="12" cy="12" r="3" /><path d="M12 2v4M12 18v4M2 12h4M18 12h4" /></Svg>;
}
